export const RequestType = Object.freeze({
  GET: 'GET',
  POST: 'POST',
  DELETE: 'DELETE',
});
